import { Injectable } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { ApiService } from "../services/api.service";
import { BehaviorSubject, Observer, Subject } from "rxjs";
import { ContactTypeResponseModel, ProjectCommentResponseModel, ProjectHistoryResponse, ProjectResponseModel, StandardResponseModel } from "../models/project.model";
import { EventResponseModel } from "../models/event.model";
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { ApiCollection } from "../providers/api-collection";
import { ClientResponseModel } from "../models/client.model";
import { ProjectsComponent } from "../pages/projects/projects.component";
import { CpdOverviewComponent } from "../components/console-project-detail/cpd-overview/cpd-overview.component";
import { ProjectPlanService } from "../services/project-plan.service";
import { ConsoleProjectTabComponent } from "../components/console-project-tab/console-project-tab.component";
import { ProjectDrawerComponent } from "../components/project-drawer/project-drawer.component";
import { CpdDriveLinksComponent } from "../components/console-project-detail/cpd-drive-links/cpd-drive-links.component";
import { CpdFilesComponent } from "../components/console-project-detail/cpd-files/cpd-files.component";


@Injectable({
    providedIn: "root",
})

export class ProjectViewModel {

    parentProjectsComponent: ProjectsComponent;
    parentConsoleProjectTabComponent: ConsoleProjectTabComponent;
    parentCpdDriveLinksComponent: CpdDriveLinksComponent;
    projectDrawerComponent:ProjectDrawerComponent;
    cpdOverviewComponent:CpdOverviewComponent;
    parentCpdFilesComponent: CpdFilesComponent;

    constructor(
        private apiService: ApiService,
        private message: NzMessageService,
        private projectPlanService: ProjectPlanService
    ) { }

    errorService = new Subject()
    linkResponse = new Subject()
    userListP = new Subject()

    projectListData = new BehaviorSubject<ProjectResponseModel>(new ProjectResponseModel());
    projectData = new BehaviorSubject<any>(undefined);
    projectContactTypeList = new BehaviorSubject<ContactTypeResponseModel>(new ContactTypeResponseModel());
    projectTypeList = new BehaviorSubject<ContactTypeResponseModel>(new ContactTypeResponseModel());
    projectStatusList = new BehaviorSubject<ContactTypeResponseModel>(new ContactTypeResponseModel());
    clientList = new BehaviorSubject<ClientResponseModel>(new ClientResponseModel());
    commentList = new BehaviorSubject<ProjectCommentResponseModel>(new ProjectCommentResponseModel());
    historyList = new BehaviorSubject<ProjectHistoryResponse>(new ProjectHistoryResponse());
    projectClosedCancelledReason = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel())
    cityList = new BehaviorSubject<any>({results: []})
    regionList = new BehaviorSubject<any>({results: []})
    projectFormatList = new BehaviorSubject<any>({results: []})
    projectFormatTypeList = new BehaviorSubject<any>({results: []})
    // Project-scoped Events list
    projectEventResponseModel = new BehaviorSubject<EventResponseModel>(new EventResponseModel());

    
    subscribeToProjects(observer: Observer<ProjectResponseModel>){
        this.projectListData.subscribe(observer)
    }


    getProjectList(page: number, page_size: number, name: string = '', caller: string ,filterObject:any={}) {
        let url = ApiCollection.Project + '?page=' + page + '&page_size=' + page_size + '&sort_by=due_date'
        if(name.length > 0){
            url += '&name=' + name
        }
          for(const [key, value ] of Object.entries(filterObject)){
            if(value != null && value != undefined && value != ''){
                if(Array.isArray(value)){
                    // Multi-select filters share the existing single-value query key; selected
                    // ids are joined with a comma into one value rather than repeating the key.
                    if(value.length > 0){
                        url += '&' + key + '=' + value.join(',')
                    }
                } else{
                    url += '&' + key + '=' + value
                }
            }
          }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:  url,
            Success: (e: any) => {
                this.projectListData.next(e)
                if(caller == 'projects'){
                    this.parentProjectsComponent.projectsReceived();
                }

                return e;
            },
            Error: (e: String) => {
                this.message.success("Project loaded unsuccessfully", {nzDuration: 1000});
                this.errorService.next(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectById(id: number, caller?: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project + '/' + id,
            Success: (e: any) => {
                this.projectData.next(e);
                this.parentConsoleProjectTabComponent.dataReceived();
                return e;
            },
            Error: (e: String) => {
                this.parentConsoleProjectTabComponent.projectDataReceivedError();
                const allErrors = Object.values(e).flat();
                allErrors.forEach(element => {
                    this.message.error(String(element), { nzDuration: 2000 });
                });
                return e;
            },
        };
        this.apiService.callService(d);
    }
    deleteProjectById(id: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Project + '/' + id,
            Success: (e: any) => {
                // this.projectData.next(e)
                this.parentConsoleProjectTabComponent.projectDeleted();
                this.message.success("Project deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.success(String(e), {nzDuration: 1000});
                console.log(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getClientList(page: number, page_size: number, name?: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: name ? ApiCollection.Client + '?page=' + page + '&page_size=' + page_size + '&name=' + name : ApiCollection.Client + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.clientList.next(e)
                //    this.message.success("Project loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Project loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

     getUserList(page:number,page_size:number,name?:string,userGroupParam?:string){
        let url = ApiCollection.User +'?page='+page+'&page_size='+page_size+'&is_deleted=false'
        if(name){
            url += '&name='+name
        }
        if(userGroupParam){
            url += '&user_group=' + userGroupParam;
        }
            let d: ApiServiceDelegate = {
                Data: { },
                Method: "GET",
                Action: url,
                Success: (e: any) => {
                   this.userListP.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

    getCityListById(page: number, page_size: number, state?: number, name?:string) {
        let url = ApiCollection.City + '?page=' + page + '&page_size=' + page_size
        if(state){
            url += '&state=' + state
        }
        if(name){
            url += '&name=' + name
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:url,
            Success: (e: any) => {
                this.cityList.next(e)
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getRegionList(name?: string) {
        let src = ApiCollection.Region + '?page=1&page_size=1000';
        if (name && name.trim().length > 0) {
            src += '&name=' + name.trim();
        }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: src,
            Success: (e: any) => {
                this.regionList.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectFormatList() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: ApiCollection.EVENT_FORMAT_TYPES,
            Success: (e: any) => {
                this.projectFormatList.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectFormatTypeList(page: number, page_size: number, opts?: { is_inperson?: boolean; is_virtual?: boolean }) {
        let url = ApiCollection.Event_Type_V2 + '?page=' + page + '&page_size=' + page_size;
        if (opts?.is_inperson) { url += '&is_inperson=true'; }
        if (opts?.is_virtual) { url += '&is_virtual=true'; }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: url,
            Success: (e: any) => {
                this.projectFormatTypeList.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    // Fetch events filtered by project id
    getEventsByProject(page: number, page_size: number, projectId: number) {
        let src = ApiCollection.Event + '?page=' + page + '&page_size=' + page_size + '&sort_by=start_datetime&sort_type=desc';
        if (projectId) {
            src += '&project=' + projectId;
        }
        const d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: src,
            Success: (e: any) => {
                this.projectEventResponseModel.next(e);
                return e;
            },
            Error: (e: any) => {
                return e;
            }
        };
        this.apiService.callService(d);
    }

    createProject(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Project,
            Success: (e: any) => {
                //    this.clientDataList.next(e)
                this.projectDrawerComponent.close(e)
                this.message.success("Project created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.success(String(e), { nzDuration: 1000 });
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateProject(data: any, id: string, caller: string) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Project + '/' + id,
            Success: (e: any) => {
                if(caller === 'app-project-drawer'){
                    this.projectDrawerComponent.close(e)
                }

                if(caller === 'app-cpd-drive-links'){
                    this.parentCpdDriveLinksComponent.projectUpdated()
                }

                  if(caller === 'app-cpd-files'){
                    this.parentCpdFilesComponent.fileCreated()
                }

      
                this.message.success("Project updated successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createProjectComment(data: any) {

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Project_Comment,
            Success: (e: any) => {
                //    this.clientDataList.next(e)
                this.cpdOverviewComponent.commentCreated()
                this.message.success("Project comment created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.success(String(e), { nzDuration: 1000 });
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateProjectComment(data: any) {

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Project_Comment + '/' + data.id,
            Success: (e: any) => {
                this.message.success("Comment updated", { nzDuration: 1000 });
                this.cpdOverviewComponent?.commentCreated();
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectComment(projectID: any) {

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project_Comment + '?project=' + projectID,
            Success: (e: any) => {
                this.commentList.next(e)
                // this.message.success("Project comment created successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectHistry(projectID: any) {

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project + '/' + projectID + '/' + 'history',
            Success: (e: any) => {
                this.historyList.next(e)
                //    this.message.success("Project comment created successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.success(String(e), { nzDuration: 1000 });
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createProjectLink(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Link,
            Success: (e: any) => {
                this.linkResponse.next(e)
                this.message.success("Project link created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.success(String(e), { nzDuration: 1000 });
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteProjectLink(id: any) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Link + '/' + id,
            Success: (e: any) => {
                this.parentCpdDriveLinksComponent.linkRemoved(id);
                this.message.success("Project link delete successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.success(String(e), { nzDuration: 1000 });
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectContactTypeList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project_Contact_Type_List + '?page=' + page + '&page_size=' + page_size + '&name=' + name,
            Success: (e: any) => {
                this.projectContactTypeList.next(e)
                //    this.message.success("Project loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Project loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectClosedCancelledReasonList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project_closed_cancelled_reason + '?page=' + page + '&page_size=' + page_size ,
            Success: (e: any) => {
                this.projectClosedCancelledReason.next(e)
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectTypeList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project_Type_List + '?page=' + page + '&page_size=' + page_size + '&name=' + name,
            Success: (e: any) => {
                this.projectTypeList.next(e)
                //    this.message.success("Project loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Project loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectStuatusList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project_Status + '?page=' + page + '&page_size=' + page_size + '&name=' + name,
            Success: (e: any) => {
                this.projectStatusList.next(e)
                //    this.message.success("Project loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Project loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectPlan(id: number){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project_Plan + '/' + id,
            Success: (e: any) => {
                this.projectPlanService.setPlanData(e);
                return e;
            },
            Error: (e: String) => {
                this.message.error("Project loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

}